import { render, staticRenderFns } from "./SupplierOrderList.vue?vue&type=template&id=5fb56445&"
import script from "./SupplierOrderList.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrderList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports